export const useSessionGuestManager = () => {
  const commerceLayerToken = useStatefulCookie<string>("cmlGuestToken", {
    maxAge: 3600
  })

  return {
    commerceLayerToken
  }
}
